import { ActionIcon, Tooltip } from "@mantine/core";
import { IconEdit } from "@tabler/icons-react";
import EditItemButton from "@/components/edit-item-button";
import licenciadaSchema from "../../schema/licenciada-schema";

const ContextMenuRow = ({ licenciada }: { licenciada: TLicenciada }) => {
  return (
    <Tooltip label="Editar">
      <ActionIcon
        variant="subtle"
        color="blue"
        component={EditItemButton}
        modal="licenciada-form-modal"
        schema={licenciadaSchema}
        item={licenciada}
        modalSize="90%"
      >
        <IconEdit size={18} />
      </ActionIcon>
    </Tooltip>
  );
};

export default ContextMenuRow;
